<template>
  <div class="esco-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.esco.title') }}</h1>
        <p>{{ $t('bo.esco.subtitle') }}</p>
      </div>
    </div>

    <div class="tabs">
      <button :class="{ active: activeTab === 'occupations' }" @click="activeTab = 'occupations'">
        {{ $t('bo.esco.tabOccupations') }}
      </button>
      <button :class="{ active: activeTab === 'skills' }" @click="activeTab = 'skills'">
        {{ $t('bo.esco.tabSkills') }}
      </button>
      <button :class="{ active: activeTab === 'skill-groups' }" @click="activeTab = 'skill-groups'">
        {{ $t('bo.esco.tabSkillGroups') }}
      </button>
      <button :class="{ active: activeTab === 'sectors' }" @click="activeTab = 'sectors'">
        {{ $t('bo.esco.tabSectors') }}
      </button>
    </div>

    <OccupationsList v-if="activeTab === 'occupations'" />
    <SkillsList v-if="activeTab === 'skills'" />
    <SkillGroupsList v-if="activeTab === 'skill-groups'" />
    <SectorsList v-if="activeTab === 'sectors'" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import OccupationsList from './OccupationsList.vue'
import SkillsList from './SkillsList.vue'
import SkillGroupsList from './SkillGroupsList.vue'
import SectorsList from './SectorsList.vue'

const activeTab = ref('occupations')
</script>

<style scoped>
.esco-manager {
  padding: 2rem;
}

.page-header {
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.tabs button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  transition: all 0.2s;
  margin-bottom: -2px;
}

.tabs button:hover { color: #3b82f6; }

.tabs button.active {
  border-bottom-color: #3b82f6;
  color: #3b82f6;
  font-weight: 600;
}
</style>
